var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.625 10.795C8.065 13.625 10.38 15.94 13.215 17.38L15.415 15.175C15.69 14.9 16.085 14.82 16.43 14.93C17.55 15.3 18.755 15.5 20 15.5C20.555 15.5 21 15.945 21 16.5V20C21 20.555 20.555 21 20 21C10.61 21 3 13.39 3 4C3 3.445 3.45 3 4 3H7.5C8.055 3 8.5 3.445 8.5 4C8.5 5.245 8.7 6.45 9.07 7.57C9.18 7.915 9.1 8.31 8.825 8.585L6.625 10.795Z",
    fill: "#8E8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGrayIcon);
export default __webpack_public_path__ + "static/media/PhoneGrayIcon.4882a3832c6e5889d6e5d68d82db3ccd.svg";
export { ForwardRef as ReactComponent };